import "./iot.css";

import React from "react";

const Iot1 = () => {
  return (
    <div>
      "texto de prueba"
      <ul className="iotGrid-container">
        <li className="iotGrid-item">
          <div className="row">
            <div className="col-1">Sensor: 2</div>
            <div className="col-2">Texto 3</div>
          </div>
          <div className="row">
            <div className="col-1">Ruido: 20</div>
            <div className="col-2">Temper: 30</div>
          </div>
          <div className="row">
            <div className="col-1">Luz: 200</div>
            <div className="col-2">Texto 300</div>
          </div>
          <div className="row">
            <div className="col-1">Power: 2000</div>
            <div className="col-2">?????: 3000</div>
          </div>
        </li>
        <li className="iotGrid-item">
        <div className="row">
            <div className="col-1">texto 2</div>
            <div className="col-2">Texto 3</div>
          </div>
          <div className="row">
            <div className="col-1">texto 20</div>
            <div className="col-2">Texto 30</div>
          </div>
          <div className="row">
            <div className="col-1">texto 200</div>
            <div className="col-2">Texto 300</div>
          </div>
          <div className="row">
            <div className="col-1">texto 2000</div>
            <div className="col-2">Texto 3000</div>
          </div>
        </li>
        <li className="iotGrid-item">Añadir_Item</li>
        <li className="iotGrid-item">Iot_1</li>
        <li className="iotGrid-item">item 5</li>
        <li className="iotGrid-item">item 6</li>
        <li className="iotGrid-item">item 7</li>
        <li className="iotGrid-item">item 8</li>
        <li className="iotGrid-item">item 9</li>
      </ul>
    </div>
  );
};

export default Iot1;
